import { render } from "./Days.vue?vue&type=template&id=3f05bb16"
import script from "./Days.vue?vue&type=script&lang=js"
export * from "./Days.vue?vue&type=script&lang=js"

import "./Days.vue?vue&type=style&index=0&id=3f05bb16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__